import type { Card } from "@/model/card";
import type { Link, LinkableCard } from "@/model/link";

import { useSessionStore } from "../session";
import { useTeamStore } from "../team";

export function linkableCardOf(card: Card, linked: boolean): LinkableCard {
  return {
    kind: "sticky",
    linked,
    id: card.id,
    groupId: card.groupId ?? undefined,
    text: card.text,
    type: card.type,
    flagType: card.flagType,
    iteration: useSessionStore().getIterationById(card.iterationId),
    team: card.teamId ? useTeamStore().findTeam({ id: card.teamId }) : undefined,
    artId: card.artId ?? undefined,
    almId: card.almId,
    status: card.status,
    points: card.points,
    precondTeam: card.precondTeam ?? undefined,
    dependTeam: card.dependTeam ?? undefined,
  };
}

export function linkId(
  card: Pick<Card, "id" | "groupId">,
): NonNullable<Card["groupId"] | Card["id"]> {
  return card.groupId || card.id;
}

export function linkBetween(card: Card, other?: Pick<Card, "id" | "groupId"> | null) {
  return (
    other && card.id !== other.id && card.linkedStickies.find((l) => l.stickyId === linkId(other))
  );
}

export function getLinkTargetId(card: Card, link: Link): string {
  return linkId(card) === link.from ? link.to : link.from;
}
